export default __webpack_public_path__ + "static/media/influens.d2da0301.svg";